'use client';

import { useEffect, useState } from 'react';
import type { IGamesListState } from '@/store/commonStore/selectors/selectGamesList';

export const useGamesListLoader = (
  { key, list, isPending, isAwaitingWallets }: IGamesListState,
  load: () => void,
  enabled = true
) => {
  const [requestedKey, setRequestedKey] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled || isPending || isAwaitingWallets) return;
    if (list && !(list.isFailed && requestedKey !== key)) return;

    setRequestedKey(key);
    load();
  }, [enabled, key, list, isPending, isAwaitingWallets, load, requestedKey]);
};
